import type { JSX } from "react";
import { Skeleton } from "@/components/ui/skeleton";

type ParagraphSkeletonProps = {
  lines?: number;
  lastShort?: boolean;
};

export const ParagraphSkeleton = ({
  lines = 3,
  lastShort = true,
}: ParagraphSkeletonProps): JSX.Element => {
  return (
    <div className="space-y-2">
      {Array.from({ length: lines }).map((_, index) => {
        const isLast = index === lines - 1;
        const widthClass = lastShort && isLast ? "w-2/3" : "w-full";
        return <Skeleton key={index} className={`h-4 ${widthClass}`} />;
      })}
    </div>
  );
};
